module.exports = __webpack_public_path__ + "static/media/launch_marina_marker.de930f0b.svg";